import React from 'react';
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';

import get from 'lodash/get';

import { classToResource, resourceHumanName } from '@src/utils/model-helpers';

const ResourceHumanNameField = ({ source }) => {
    const record = useRecordContext();
    const recordType = get(record, source);

    if (!recordType) return null;

    const resource = classToResource(recordType);
    const humanName = resourceHumanName(resource);

    return (
        <span>{humanName}</span>
    );
};

ResourceHumanNameField.propTypes = {
    source: PropTypes.string.isRequired,
};

export default ResourceHumanNameField;
